export default {
	$uikit: {
		search: 'جستجو...',
		select: 'انتخاب کنید',
		itemsSelected: '{count}  مورد انتخاب شده',
		noDataToShow: 'موردی برای نمایش وجود ندارد',
		submit: 'تایید',
		cancel: 'انصراف',
		anErrorAccoutred: 'خطایی رخ داد!',
		connectionError: 'خطا در برقراری ارتباط',
		file: 'فایل',
		from: 'از',
		until: 'تا',
		and: 'و',
		hour: 'ساعت',
		goToToday: 'برو به امروز',
		now: 'اکنون',
		changeDate: 'تغییر تاریخ',
		removeAllFilters: 'حذف همه فیلترها',
		filter: 'اعمال فیلتر',
		dashboard: 'داشبورد',
		count: 'تعداد',
		showing: 'نمایش {start} - {end} از {total}',
		resultFound: '{count} نتیجه یافت شد',
		edit: 'ویرایش',
		saveChanges: 'ذخیره تغییرات',
		save: 'ذخیره',
		currency: {
			IRR: 'ریال',
			IRT: 'تومان'
		},
		prioritizingFilters: 'اولویت بندی فیلترها',
		columnCustomization: 'شخصی سازی ستون ها',
		columnCustomizationDescription:
			'ستون‌های موردنظر برای نمایش در جدول را انتخاب و مرتب‌سازی کنید.',
		columnCustomizationMaxColumnInfo:
			'حداکثر تعداد ستون های قابل مشاهده، {max} عدد است',
		columnCustomizationMinColumnInfo:
			'حداقل تعداد ستون های قابل مشاهده، {min} عدد است',
		operation: 'عملیات',
		rowIndex: 'ردیف',
		noDataToShowBasedOnSelectedFilters:
			'با توجه به فیلتر اعمال شده، موردی برای نمایش وجود ندارد',
		changeFiltersToShowMoreItems:
			'برای مشاهده موارد بیشتر فیلتر ها را تغییر دهید'
	},
	$validator: {
		invalid: {
			default: 'مقدار وارد شده معتبر نیست',
			labeled: '{label} وارد شده معتبر نیست'
		},
		required: {
			default: 'وارد کردن این فیلد الزامی است',
			labeled: 'وارد کردن {label} الزامی است'
		},
		length: {
			default: 'مقدار این فیلد باید دقیقا {length} کاراکتر باشد',
			labeled: '{label} باید دقیقا {length} کاراکتر باشد'
		},
		minLength: {
			default: 'مقدار این فیلد باید حداقل {length} کاراکتر باشد',
			labeled: '{label} باید حداقل {length} کاراکتر باشد'
		},
		maxLength: {
			default: 'مقدار این فیلد باید حداکثر {length} کاراکتر باشد',
			labeled: '{label} باید حداکثر {length} کاراکتر باشد'
		},
		equalTo: {
			default: 'مقدار این فیلد باید برابر مقدار {otherLabel} باشد',
			labeled: '{label}، با {otherLabel} مطابقت ندارد'
		},
		min: {
			default: 'مقدار این فیلد باید بیشتر از {min} باشد',
			labeled: '{label} باید بیشتر از {min} باشد'
		},
		max: {
			default: 'مقدار این فیلد باید کمتر از {max} باشد',
			labeled: '{label} باید کمتر از {max} باشد'
		},
		persianCharacters: {
			default: 'مقدار این فیلد باید فقط شامل حروف فارسی بدون علائم و عدد باشد',
			labeled: '{label} باید فقط شامل حروف فارسی بدون علائم و عدد باشد'
		},
		fileMaxCount: {
			default: 'نمی توانید بیشتر از {maxCount} فایل انتخاب کنید',
			labeled: 'نمی توانید بیشتر از {maxCount} فایل انتخاب کنید'
		},
		fileMinCount: {
			default: 'حداقل {minCount} فایل انتخاب کنید',
			labeled: 'حداقل {minCount} فایل انتخاب کنید'
		},
		fileMaxSize: {
			default: 'حجم فایل نباید بیشتر از {maxSize} باشد',
			labeled: 'حجم فایل نباید بیشتر از {maxSize} باشد'
		},
		fileType: {
			default: 'فقط فایل های {types} قابل قبول هستند',
			labeled: 'برای {label} فقط فایل های {types} قابل قبول هستند'
		}
	}
}
